<template>
<div :id="tabid" class="song-list-container">
    <div class="row">
        <div class="col-xs-12">
            <div class="search-input">
                <input type="text" class="browser-default dark" placeholder="Search through lists ..." v-model="searchText">
                <span v-show="!searchText.length">
                    <i class="iconify icon:ic:outline-search"></i>
                </span>
                <span v-show="searchText.length" @click="cancelSearch">
                    <i class="iconify icon:mdi:close-circle"></i>
                </span>   
            </div>
        </div>
    </div>

	<div class="song-list row m-h--5">
        <div class="song-widget col-xs-6 p-h-5 button" v-if="searchValidate('Liked Songs')">
        	<router-link :to="'/playlist/liked'" tag="div" class="inner-container">
	    		<div class="thumbnail"><span class="iconify icon:mdi:playlist-music"></span></div>
	    		<h4 class="artist">Liked Songs</h4>
	    		<h4 class="name">DEFAULT LIST</h4>

	            <div class="more">
	                <i class="iconify" data-icon="zmdi:more" data-height="24" data-width="24" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
	            </div>
        	</router-link>
        </div>

        <div class="song-widget col-xs-6 p-h-5 button" v-if="searchValidate('Liked Songs')">
        	<router-link :to="'/playlist/disliked'" tag="div" class="inner-container">
	    		<div class="thumbnail"><span class="iconify icon:mdi:playlist-music"></span></div>
	    		<h4 class="artist">Disliked Songs</h4>
	    		<h4 class="name">DEFAULT LIST</h4>

	            <div class="more">
	                <i class="iconify" data-icon="zmdi:more" data-height="24" data-width="24" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
	            </div>
        	</router-link>
        </div>

	    <div class="song-widget col-xs-6 p-h-5" v-for="(p,i) in playlists" v-if="searchValidate(p.name)" :class="{'last last-loaded' : i == playlists.length - 1}">
    		<router-link :to="'/playlist/'+ p.id" tag="div" class="inner-container">
	    		<div class="thumbnail" :style="'background-image: url(' + getImage(p.image_name) + ')'"></div>
	    		<h4 class="artist">{{p.name}}</h4>
	    		<h4 class="name">{{p.songs_count}} TRACKS</h4>

	            <div class="more">
	                <i class="iconify" data-icon="zmdi:more" data-height="24" data-width="24" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
	            </div>
	        </router-link>
	    </div>

		<div class="no-results" v-show="!hasResults">
			<span class="iconify icon:mdi:playlist-remove"></span><br>
			No playlists found<br>matching the search
		</div>		    
	</div>
</div>
</template>

<script>
export default {
    props: {
        tabid: { default: null },
    },

    data() {
        return {
            playlists: false,
            scrollPosition: {
                left: 0,
            },              
            searchText: '',
            hasResults: true
        }
    },    

    activated(){
        $(`#${this.tabid} .song-list`).scrollLeft(this.scrollPosition.left);
    },

    mounted() {
        this.playlists = App.playlists;

        //horizontal
        $(`#${this.tabid} .song-list`).on('scroll', () => {
            this.scrollPosition.left = $(`#${this.tabid} .song-list`).scrollLeft();
        })

        var that = this;
        var scrollTimer = false;

        //horizontal
        $(`#${this.tabid} .song-list`).on('touchstart', function() {
            clearTimeout(scrollTimer);
        }).on('touchend', function(){
            scrollTimer = setTimeout(() => {
                var W = $(this).find('.song-widget').width() + 10;
                $(this).animate({ scrollLeft: Math.round($(this)[0].scrollLeft / W) * W }, 250);
            }, 750);
        })        
    },

    methods: {
        searchValidate(name) {
            return this.searchText.length ? (name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) : true;
        },

        removePlaylist(pid) {
            this.$http.delete(this.getListsEndpoint +'/'+ pid).then((success) => {
                this.playlists = $.grep(this.playlists, (p) => {
                    return pid != p.id;
                });

                window.App.playlists = this.playlists;
                if (typeof mixpanel !== 'undefined') {
                    mixpanel.track(`Removed playlist ${pid}`);
                }
            });
        },

        cancelSearch(){
            $('.search-input').blur();
            this.searchText = '';
        },          

        getImage(img) {
            return App.restApi + '/api/image/' + img; 
        }
    },

    computed: {
        getListsEndpoint() {
            return App.restApi + '/api/v2/playlists';
        },
    },

    watch: {
    	searchText(){
            clearTimeout(this.searchDelay);
            this.searchDelay = setTimeout(() => {
                this.$nextTick(() => {
                    this.hasResults = $(`#${this.tabid} .song-widget:visible`).length > 0;
                });

                if (App.allowGtag) gtag('event', 'search_playlist', {
                    'event_category' : 'mystuff',
                    'event_label' : `Search playlist in My stuff / Playlists`
                });                
            }, 750);
    	}
    }
}
</script>
